import { Outlet } from 'react-router-dom';
import { ScrollToTop } from '@/components/ScrollToTop';

export default function EleccionLayout() {
  return (
    <>
      <ScrollToTop />
      {/* Main Content */}
      <Outlet />
    </>
  );
}